










































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TaskConfirmationModal extends Vue {
    @Prop({ default: false }) readonly value!: boolean;
    @Prop({ default: 'Warning' }) readonly title!: string;
    @Prop({ default: 'Are you sure you want to proceed?' }) readonly message!: string;

    get isOpen(): boolean {
        return this.value;
    }

    set isOpen(value: boolean) {
        this.$emit('input', value);
    }

    handleClose() {
        this.$emit('cancel');
        this.isOpen = false;
    }

    handleCancel() {
        this.$emit('cancel');
        this.isOpen = false;
    }

    handleProceed() {
        this.$emit('proceed');
        this.isOpen = false;
    }
}
